import cx from 'classnames';
import {
    BZ2_DELETED_REASONS_ALREADY_DELETED,
    BZ2_DELETED_REASONS_CANCEL,
    BZ2_DELETED_REASONS_SELLER_MESSAGE_HEADLINE,
    BZ2_DELETED_REASONS_SUBMIT,
    DELETED_REASON_ANOTHER_BAZAAR,
    DELETED_REASON_ANOTHER_BAZAAR_ADMIN_NOTE,
    DELETED_REASON_ANOTHER_BAZAAR_MESSAGE,
    DELETED_REASON_COPYRIGHT_PHOTOS,
    DELETED_REASON_COPYRIGHT_PHOTOS_ADMIN_NOTE,
    DELETED_REASON_COPYRIGHT_PHOTOS_MESSAGE,
    DELETED_REASON_DONT_KNOW_WHAT_SELLING,
    DELETED_REASON_DONT_KNOW_WHAT_SELLING_ADMIN_NOTE,
    DELETED_REASON_DONT_KNOW_WHAT_SELLING_MESSAGE,
    DELETED_REASON_INVISIBLE_PRODUCT,
    DELETED_REASON_INVISIBLE_PRODUCT_ADMIN_NOTE,
    DELETED_REASON_INVISIBLE_PRODUCT_MESSAGE,
    DELETED_REASON_LANGUAGE,
    DELETED_REASON_LANGUAGE_MESSAGE,
    DELETED_REASON_LANGUAGE_NOTE,
    DELETED_REASON_NOT_ALLOWED,
    DELETED_REASON_NOT_ALLOWED_ADMIN_NOTE,
    DELETED_REASON_NOT_ALLOWED_ANNOUNCEMENT,
    DELETED_REASON_NOT_ALLOWED_ANNOUNCEMENT_MESSAGE,
    DELETED_REASON_NOT_ALLOWED_ANNOUNCEMENT_NOTE,
    DELETED_REASON_NOT_ALLOWED_DRUGS,
    DELETED_REASON_NOT_ALLOWED_DRUGS_MESSAGE,
    DELETED_REASON_NOT_ALLOWED_DRUGS_NOTE,
    DELETED_REASON_NOT_ALLOWED_DUPLICATE,
    DELETED_REASON_NOT_ALLOWED_DUPLICATE_MESSAGE,
    DELETED_REASON_NOT_ALLOWED_DUPLICATE_NOTE,
    DELETED_REASON_NOT_ALLOWED_INQUIRY,
    DELETED_REASON_NOT_ALLOWED_INQUIRY_MESSAGE,
    DELETED_REASON_NOT_ALLOWED_INQUIRY_NOTE,
    DELETED_REASON_NOT_ALLOWED_MESSAGE,
    DELETED_REASON_NOT_ALLOWED_OPEN,
    DELETED_REASON_NOT_ALLOWED_OPEN_MESSAGE,
    DELETED_REASON_NOT_ALLOWED_OPEN_NOTE,
    DELETED_REASON_NOT_FOR_TWINS,
    DELETED_REASON_NOT_FOR_TWINS_ADMIN_NOTE,
    DELETED_REASON_NOT_FOR_TWINS_MESSAGE,
    DELETED_REASON_SERVICE,
    DELETED_REASON_SERVICE_MESSAGE,
    DELETED_REASON_SERVICE_NOTE,
    DELETED_REASON_WRONG_PRICE,
    DELETED_REASON_WRONG_PRICE_ADMIN_NOTE,
    DELETED_REASON_WRONG_PRICE_MESSAGE,
    FORMS_DEFAULT_REQUIRED_FIELD_ERROR,
} from 'mk/autogenerated/translations/DeletedReasonForm.1b26bd75db89655926f56e89978c8a5d'
import { DeletedReason } from 'mk2/apps/bazaar/schemas';
import { RadioField, RadioOption } from 'mk2/components/forms/RadioField';
import { SubmitButton } from 'mk2/components/forms/SubmitButton';
import { Btn, BtnType } from 'mk2/components/Btn';
import { Form } from 'mk2/components/Form';
import { Interpolate } from 'mk2/components/Interpolate';
import { mkReduxForm, MKReduxFormInjectedProps } from 'mk2/decorators/mkReduxForm';
import { AppState } from 'mk2/reducers';
import React from 'react';
import { connect } from 'react-redux';
import { formValueSelector, FormErrors } from 'redux-form';
import styles from './DeletedReasonForm.mscss';

export const FORM_NAME = 'DELETED_REASON_FORM';

const reasons: RadioOption[] = [
    { value: DeletedReason.DELETED_REASON_COPYRIGHT_PHOTOS, label: DELETED_REASON_COPYRIGHT_PHOTOS },
    { value: DeletedReason.DELETED_REASON_INVISIBLE_PRODUCT, label: DELETED_REASON_INVISIBLE_PRODUCT },
    { value: DeletedReason.DELETED_REASON_WRONG_PRICE, label: DELETED_REASON_WRONG_PRICE },
    { value: DeletedReason.DELETED_REASON_DONT_KNOW_WHAT_SELLING, label: DELETED_REASON_DONT_KNOW_WHAT_SELLING },
    { value: DeletedReason.DELETED_REASON_NOT_ALLOWED_DUPLICATE, label: DELETED_REASON_NOT_ALLOWED_DUPLICATE },
    { value: DeletedReason.DELETED_REASON_NOT_ALLOWED_OPEN, label: DELETED_REASON_NOT_ALLOWED_OPEN },
    { value: DeletedReason.DELETED_REASON_NOT_ALLOWED_DRUGS, label: DELETED_REASON_NOT_ALLOWED_DRUGS },
    { value: DeletedReason.DELETED_REASON_NOT_ALLOWED_INQUIRY, label: DELETED_REASON_NOT_ALLOWED_INQUIRY },
    { value: DeletedReason.DELETED_REASON_NOT_ALLOWED_ANNOUNCEMENT, label: DELETED_REASON_NOT_ALLOWED_ANNOUNCEMENT },
    // not used anymore
    // { value: DeletedReason.DELETED_REASON_ANOTHER_BAZAAR, label: DELETED_REASON_ANOTHER_BAZAAR },
    { value: DeletedReason.DELETED_REASON_NOT_ALLOWED, label: DELETED_REASON_NOT_ALLOWED },
    { value: DeletedReason.DELETED_REASON_NOT_FOR_TWINS, label: DELETED_REASON_NOT_FOR_TWINS },
    { value: DeletedReason.DELETED_REASON_LANGUAGE, label: DELETED_REASON_LANGUAGE },
];

const sellerMessages = {
    [DeletedReason.DELETED_REASON_COPYRIGHT_PHOTOS]: DELETED_REASON_COPYRIGHT_PHOTOS_MESSAGE,
    [DeletedReason.DELETED_REASON_WRONG_PRICE]: DELETED_REASON_WRONG_PRICE_MESSAGE,
    [DeletedReason.DELETED_REASON_INVISIBLE_PRODUCT]: DELETED_REASON_INVISIBLE_PRODUCT_MESSAGE,
    [DeletedReason.DELETED_REASON_DONT_KNOW_WHAT_SELLING]: DELETED_REASON_DONT_KNOW_WHAT_SELLING_MESSAGE,
    [DeletedReason.DELETED_REASON_NOT_FOR_TWINS]: DELETED_REASON_NOT_FOR_TWINS_MESSAGE,
    [DeletedReason.DELETED_REASON_NOT_ALLOWED]: DELETED_REASON_NOT_ALLOWED_MESSAGE,
    [DeletedReason.DELETED_REASON_SERVICE]: DELETED_REASON_SERVICE_MESSAGE,
    [DeletedReason.DELETED_REASON_LANGUAGE]: DELETED_REASON_LANGUAGE_MESSAGE,
    [DeletedReason.DELETED_REASON_NOT_ALLOWED_DUPLICATE]: DELETED_REASON_NOT_ALLOWED_DUPLICATE_MESSAGE,
    [DeletedReason.DELETED_REASON_NOT_ALLOWED_DRUGS]: DELETED_REASON_NOT_ALLOWED_DRUGS_MESSAGE,
    // not used anymore
    // [DeletedReason.DELETED_REASON_ANOTHER_BAZAAR]: DELETED_REASON_ANOTHER_BAZAAR_MESSAGE,
    [DeletedReason.DELETED_REASON_NOT_ALLOWED_OPEN]: DELETED_REASON_NOT_ALLOWED_OPEN_MESSAGE,
    [DeletedReason.DELETED_REASON_NOT_ALLOWED_ANNOUNCEMENT]: DELETED_REASON_NOT_ALLOWED_ANNOUNCEMENT_MESSAGE,
    [DeletedReason.DELETED_REASON_NOT_ALLOWED_INQUIRY]: DELETED_REASON_NOT_ALLOWED_INQUIRY_MESSAGE,
};

const adminNotes = {
    [DeletedReason.DELETED_REASON_COPYRIGHT_PHOTOS]: DELETED_REASON_COPYRIGHT_PHOTOS_ADMIN_NOTE,
    [DeletedReason.DELETED_REASON_WRONG_PRICE]: DELETED_REASON_WRONG_PRICE_ADMIN_NOTE,
    [DeletedReason.DELETED_REASON_INVISIBLE_PRODUCT]: DELETED_REASON_INVISIBLE_PRODUCT_ADMIN_NOTE,
    [DeletedReason.DELETED_REASON_DONT_KNOW_WHAT_SELLING]: DELETED_REASON_DONT_KNOW_WHAT_SELLING_ADMIN_NOTE,
    [DeletedReason.DELETED_REASON_NOT_FOR_TWINS]: DELETED_REASON_NOT_FOR_TWINS_ADMIN_NOTE,
    [DeletedReason.DELETED_REASON_NOT_ALLOWED]: DELETED_REASON_NOT_ALLOWED_ADMIN_NOTE,
    [DeletedReason.DELETED_REASON_SERVICE]: DELETED_REASON_SERVICE_NOTE,
    [DeletedReason.DELETED_REASON_LANGUAGE]: DELETED_REASON_LANGUAGE_NOTE,
    [DeletedReason.DELETED_REASON_NOT_ALLOWED_DUPLICATE]: DELETED_REASON_NOT_ALLOWED_DUPLICATE_NOTE,
    [DeletedReason.DELETED_REASON_NOT_ALLOWED_DRUGS]: DELETED_REASON_NOT_ALLOWED_DRUGS_NOTE,
    // not used anymore
    // [DeletedReason.DELETED_REASON_ANOTHER_BAZAAR]: DELETED_REASON_ANOTHER_BAZAAR_ADMIN_NOTE,
    [DeletedReason.DELETED_REASON_NOT_ALLOWED_OPEN]: DELETED_REASON_NOT_ALLOWED_OPEN_NOTE,
    [DeletedReason.DELETED_REASON_NOT_ALLOWED_ANNOUNCEMENT]: DELETED_REASON_NOT_ALLOWED_ANNOUNCEMENT_NOTE,
    [DeletedReason.DELETED_REASON_NOT_ALLOWED_INQUIRY]: DELETED_REASON_NOT_ALLOWED_INQUIRY_NOTE,
};

export interface DeletedReasonFormData {
    reason: DeletedReason;
}

interface OwnProps {
    className?: string;
    alreadyDeleted?: boolean;

    onSave(values: DeletedReasonFormData);
    onCancel(event: React.MouseEvent<HTMLAnchorElement>);
}

interface StateProps {
    reason: DeletedReason;
    initialValues: DeletedReasonFormData;
}

interface DispatchProps {}

type Props = OwnProps & StateProps & DispatchProps;

class DeletedReasonForm extends React.Component<Props & MKReduxFormInjectedProps<DeletedReasonFormData, Props>> {
    public render() {
        const { className, handleSubmit, alreadyDeleted, form, onCancel, reason } = this.props;

        const sellerMessage = reason ? sellerMessages[reason] : null;
        const adminNote = reason ? adminNotes[reason] : null;

        return (
            <Form className={cx(styles.DeletedReasonForm, className)} onSubmit={handleSubmit}>
                {alreadyDeleted ? (
                    BZ2_DELETED_REASONS_ALREADY_DELETED
                ) : (
                    <>
                        <div className={styles.DeletedReasonForm__columns}>
                            <div className={styles.DeletedReasonForm__reasons}>
                                <RadioField
                                    name="reason"
                                    options={reasons}
                                    label={BZ2_DELETED_REASONS_SELLER_MESSAGE_HEADLINE}
                                    bottomBorder={false}
                                />
                            </div>

                            {reason && (
                                <div className={styles.DeletedReasonForm__messages}>
                                    <div className={styles.DeletedReasonForm__header}>
                                        {BZ2_DELETED_REASONS_SELLER_MESSAGE_HEADLINE}
                                    </div>
                                    <Interpolate
                                        parent="div"
                                        className={styles.DeletedReasonForm__sellerMessage}
                                        i18nKey={sellerMessage}
                                        useDangerouslySetInnerHTML
                                    />

                                    {adminNote ? (
                                        <Interpolate
                                            parent="div"
                                            className={styles.DeletedReasonForm__sellerMessage}
                                            i18nKey={adminNote}
                                            useDangerouslySetInnerHTML
                                        />
                                    ) : null}
                                </div>
                            )}
                        </div>
                        <div className={styles.DeletedReasonForm__actionButtons}>
                            <Btn
                                className={styles.ReviewForm__cancel}
                                type={BtnType.Link}
                                label={BZ2_DELETED_REASONS_CANCEL}
                                onClick={onCancel}
                            />
                            <SubmitButton
                                className={styles.ReviewForm__submit}
                                label={BZ2_DELETED_REASONS_SUBMIT}
                                formName={form}
                                btnType={BtnType.Blue}
                            />
                        </div>
                    </>
                )}
            </Form>
        );
    }
}

function validate(values: DeletedReasonFormData): FormErrors<DeletedReasonFormData> {
    const errors: FormErrors<DeletedReasonFormData> = {};
    if (!values.reason) {
        errors.reason = FORMS_DEFAULT_REQUIRED_FIELD_ERROR;
    }

    return errors;
}

const DeletedReasonFormForm = mkReduxForm<DeletedReasonFormData, Props>({
    onValidate: validate,
    formName: FORM_NAME,
    onSave: (values, props) => props.onSave(values),
})(DeletedReasonForm);

const selector = formValueSelector(FORM_NAME);

const initialValues: DeletedReasonFormData = {
    reason: null,
};

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    return {
        reason: selector(state, 'reason'),
        initialValues,
    };
}

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, null)(DeletedReasonFormForm);
